import { getURl } from "services/core";
import ImportForm from "common/components/ImportForm";

const url = `${getURl()}/project/v1/import_sub_project`;
export default ImportForm({
  title: "Import Sub Projects",
  onBackLink: "/donor",
  titleBeforeUpload: "Are you sure you want to import sub projects?",
  textBeforeUpload: "This will import the donor for employees. Do you want to continue?",
  textUpload: "Upload a spreatsheet to import sub projects.",
  fileName: "Donor Import Donor  Project, SubProject, Activities.xlsx",
  url,
});

